import Particles from 'react-particles-js'

export default function CustomParticles(props) {
    return (
        <Particles
            height='99vh'
            width='99vw'
            canvasClassName='landing'
            params={{
                particles: {
                    number: {
                        value: props.numParticles
                    },
                    opacity: {
                        value: 0.5
                    },
                    color: {
                        value: '#000000'
                    },
                    lineLinked: {
                        color: {
                            value: '#000000'
                        }
                    },
                    move: {
                        speed: 0.8
                    },
                },
                interactivity: {
                    detect_on: "canvas",
                    events: {
                        onhover: {
                            enable: true,
                            mode: "repulse"
                        },
                        onclick: {
                            enable: true,
                            mode: "push"
                        },
                        resize: true
                    },
                },
            }}
        />
    )
}